import { PageDemos } from '@sloyd/app-demos';
import {
  PageEditor,
  PageEmbed,
  PageJson,
  PageMobile,
  PagePlayground,
  PageRecorder,
} from '@sloyd/app-editor';
import { PageChangeLog, PageHome, PageLogout } from '@sloyd/app-home';
import { PageLabs, PageWireframes } from '@sloyd/app-labs';
import { PageLanding } from '@sloyd/app-landing';
import { PageLanding as PageLandingB2b } from '@sloyd/app-landing-b2b';
import { PageHome as PagePlatform } from '@sloyd/app-platform';
import { PageStory } from '@sloyd/ui';
import { Viewer, ViewerRaw } from '@sloyd/viewer';
import { LoginContainer as PageLogin } from '../containers/Login.container';

export const pages = {
  Viewer,
  ViewerRaw,
  PageRecorder,
  PageJson,
  PageEditor,
  PagePlayground,
  PageLanding,
  PageLandingB2b,
  PageMobile,
  PageLabs,
  PageChangeLog,
  PageWireframes,
  PageDemos,
  PageEmbed,
  PageHome,
  PagePlatform,
  PageStory,
  PageLogout,
  PageLogin,
};
